import { useEffect, useState } from 'react'
import { MIC_LEVEL_FFT_SIZE, MIC_LEVEL_GAIN } from '../constants/device.constants'
import { getAudioContextCtor } from '../utils/device-permissions'

export function useMicLevel(stream: MediaStream | null): number {
  const [level, setLevel] = useState(0)

  useEffect(() => {
    if (!stream) {
      setLevel(0)
      return
    }
    const audioTrack = stream.getAudioTracks()[0]
    if (!audioTrack) {
      setLevel(0)
      return
    }

    const AudioCtor = getAudioContextCtor()
    if (!AudioCtor) return

    const ctx = new AudioCtor()
    const src = ctx.createMediaStreamSource(new MediaStream([audioTrack]))
    const analyser = ctx.createAnalyser()
    analyser.fftSize = MIC_LEVEL_FFT_SIZE
    src.connect(analyser)

    const data = new Uint8Array(analyser.frequencyBinCount)
    let raf = 0
    let cancelled = false

    const tick = () => {
      if (cancelled) return
      analyser.getByteTimeDomainData(data)
      let sum = 0
      for (let i = 0; i < data.length; i++) {
        const v = (data[i] - 128) / 128
        sum += v * v
      }
      setLevel(Math.min(1, Math.sqrt(sum / data.length) * MIC_LEVEL_GAIN))
      raf = requestAnimationFrame(tick)
    }
    raf = requestAnimationFrame(tick)

    return () => {
      cancelled = true
      cancelAnimationFrame(raf)
      ctx.close().catch(() => {})
    }
  }, [stream])

  return level
}
